//
// HistoryManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";
import "../models/local/Folder";

var HistoryManager = createModule("transport::HistoryManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getRootHistoryFolder: [1],
        getHistory: [1],
        removeFromHistory: [1,1],
        clearHistory: [1],
        addToHistory: [1,1],
    },
    ,
    ,
]);
export default HistoryManager;
